import { ServiceFeePayer } from '@/apis/payments/service_fee.schema'
import { Card, CardContent } from '@/app/common/components/Card'
import { currencyFormatter } from '@/app/common/utilities'
import { useTranslation } from 'react-i18next'
import { getTotalServiceFeeToBePaidByApplicant } from '../../utils/payment/utils'
import { ApplicantPaymentAmount } from '../../payment.utils'

interface PaymentSummaryProps {
  paymentAmount: ApplicantPaymentAmount
  serviceFeeAmount: number
  serviceFeePayer: ServiceFeePayer
  baseAmount: number
}

export const PaymentSummary = ({
  paymentAmount,
  baseAmount,
  serviceFeeAmount,
  serviceFeePayer,
}: PaymentSummaryProps) => {
  const { t: translate } = useTranslation()

  const serviceFee = getTotalServiceFeeToBePaidByApplicant(
    serviceFeeAmount,
    serviceFeePayer
  )

  return (
    <Card>
      <CardContent>
        <div className="space-y-2">
          <p className="flex w-full text-base text-gray-700 justify-between font-normal"></p>
          <p className="flex w-full text-base text-gray-700 justify-between font-normal">
            <span>{translate('your_total_is')}:</span>
            <span className="font-medium">
              {currencyFormatter.format(paymentAmount)}
            </span>
          </p>
          <p className="flex w-full text-base text-gray-700 justify-between font-normal">
            <span>{translate('service_fee')}:</span>
            <span className="font-medium">
              {currencyFormatter.format(serviceFee)}
            </span>
          </p>
          <p className="flex w-full text-base text-gray-700 justify-between font-normal">
            <span>{translate('amount_from_wallet')}:</span>
            <span className="font-medium">
              {currencyFormatter.format(paymentAmount)}
            </span>
          </p>
          <p className="flex w-full text-base text-gray-700 justify-between font-normal">
            <span>{translate('amount_to_provider')}:</span>
            <span className="font-medium">
              {currencyFormatter.format(baseAmount)}
            </span>
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
